import { Component } from 'react';

const BODY_SCROLL_LOCK_CLASS = 'body-scroll-lock';

const WithBodyScrollLock = (WrappedComponent) => {
  class ComponentWithBodyScrollLock extends Component {
    componentWillUnmount() {
      // safety net in case the wrapped component unmounts while still locked
      document.body.classList.remove(BODY_SCROLL_LOCK_CLASS);
    }

    lockScroll = () => {
      document.body.classList.add(BODY_SCROLL_LOCK_CLASS);
    };

    unlockScroll = () => {
      document.body.classList.remove(BODY_SCROLL_LOCK_CLASS);
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          lockScroll={this.lockScroll}
          unlockScroll={this.unlockScroll}
        />
      );
    }
  }

  ComponentWithBodyScrollLock.displayName = `WithBodyScrollLock(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return ComponentWithBodyScrollLock;
};

export { WithBodyScrollLock };
